import type { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  action?: ReactNode;
};

export function PageHero({
  icon,
  title,
  subtitle,
  action,
}: Props) {
  return (
    <section className="mb-7 rounded-3xl border border-slate-800 bg-gradient-to-r from-slate-900 via-slate-900 to-slate-950 p-7 shadow-sm shadow-black/20">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-5">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500/30 to-violet-500/20 text-indigo-300 ring-1 ring-inset ring-indigo-400/20">
            {icon}
          </div>

          <div>
            <h1 className="text-3xl font-bold tracking-tight text-white">
              {title}
            </h1>

            <p className="mt-2 text-base text-slate-400">
              {subtitle}
            </p>
          </div>
        </div>

        {action}
      </div>
    </section>
  );
}